<template>
  <section id="section-excluded">
    <SectionHeading id="toc-excluded" icon="icon-common-file-text-remove" title="Not included" />

    <ul class="items">
      <li v-for="line in itinerary.productExcludedInPriceHtml">
        <i class="icon icon-remove-circle"></i>
        <div v-html="line"></div>
      </li>
    </ul>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'

const store = useItineraryStore()
const {
  data: { itinerary },
} = store
store.monitorVisibility('excluded', '#section-excluded')
</script>

<style lang="scss" scoped>
section {
  @include flex-column(20px);
}

.items {
  @include flex-column(20px);

  li {
    display: flex;
    gap: 12px;
    font-weight: 400;
  }

  .icon {
    color: $brand-secondary;
  }
}
</style>
